/**
 * Any Apple hardware: Mac, iPhone, iPod and iPad. iPadOS 13+ presents itself as a Mac
 * (`Macintosh` in the UA), which the last alternative absorbs.
 */
export const isAppleDevice = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
};

/**
 * iPhone, iPod and iPad only — a Mac is excluded. iPadOS 13+ reports itself as a Mac and is
 * only told apart by its touch points (a Mac trackpad counts for none).
 */
export const isAppleTouchDevice = (): boolean => {
  if (typeof navigator === "undefined") return false;
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) return true;
  return /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
};
